import { useTheme } from '@simplywallst/ui-core';
import { VerticalStackBarChart } from '../VerticalStackBarChart';

const keys = ['Last 12m', 'Next 12m', '+2 year', '+3 year'];

const columnStackKeys = ['High', 'Medium', 'Low'];

export const DividendQualityForecastBarChart = () => {
  const theme = useTheme();

  const columnStackColors = [
    theme.color.good,
    theme.color.warning,
    theme.color.bad,
  ];

  const entities = {
    [keys[0]]: [100, null, 300],
    [keys[1]]: [10, 20, 30],
    [keys[2]]: [100, 100, 300],
    [keys[3]]: [],
  };

  const entitiesFormatted = {
    [keys[0]]: '13.8%',
    [keys[1]]: '13.9%',
    [keys[2]]: '13.10%',
    [keys[3]]: '0%',
  };

  return (
    <VerticalStackBarChart
      entities={entities}
      entitiesFormatted={entitiesFormatted}
      keys={keys}
      height={250}
      columnStackColors={columnStackColors}
      columnStackKeys={columnStackKeys}
      onSelectingColumn={() => {}}
      initialSelectedColumn={keys[1]}
    />
  );
};
